import { Link } from 'react-router-dom';
import { navCategories } from '@/mocks/categories';
import { shows } from '@/mocks/shows';

export default function CategoryGrid() {
  return (
    <section className="px-4 md:px-6 py-10 md:py-14">
      <div className="flex items-center gap-3 mb-6">
        <span className="w-10 h-10 flex items-center justify-center rounded-md bg-primary-100 text-primary-600">
          <i className="ri-apps-2-line text-xl"></i>
        </span>
        <div>
          <h2 className="font-heading text-lg md:text-2xl font-bold text-foreground-950">按分类浏览</h2>
          <p className="text-xs md:text-sm text-foreground-500 mt-0.5">快速进入你感兴趣的剧集类别</p>
        </div>
      </div>

      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-3 md:gap-4">
        {navCategories.map((category) => {
          const count = shows.filter((show) => show.categories.includes(category.slug)).length;
          return (
            <Link
              key={category.slug}
              to={`/category/${category.slug}`}
              className="group flex flex-col items-center text-center gap-2 p-4 md:p-5 rounded-lg bg-background-100 border border-background-200 hover:border-primary-300 hover:bg-background-50 transition-all cursor-pointer"
            >
              <span className="w-12 h-12 md:w-14 md:h-14 flex items-center justify-center rounded-full bg-background-50 text-primary-600 group-hover:bg-primary-500 group-hover:text-background-50 transition-colors">
                <i className={`${category.icon} text-2xl`}></i>
              </span>
              <span className="font-heading font-semibold text-sm md:text-base text-foreground-900">
                {category.name}
              </span>
              <span className="text-xs text-foreground-500">{count} 部剧集</span>
            </Link>
          );
        })}
      </div>
    </section>
  );
}